<div class="modal">
    <div class="containn">
        <div class="cuadReg">
            <span class="close2" (click)="closeModal()" *ngIf="showClose">&times;</span>
            <div class="title">
                <h3>Regístrate en Triidy</h3>
            </div>
            <div class="formul">
                <form action="" [formGroup]="registerForm">
                    <mat-form-field appearance="outline">
                        <mat-label>Correo Electronico</mat-label>
                        <input matInput placeholder="Correo Electronico" name="correo" id="correo" formControlName="correo" (focusout)="onFocusOutEventEmail()" #correo required>
                        <mat-hint>{{correo.value?.length || 0}}/60</mat-hint>
                        <!-- <mat-error *ngIf="getControl('correo')">Correo incorrecto
                        </mat-error> -->
                    </mat-form-field>
                    <br>
                    <mat-form-field appearance="outline">
                        <mat-label>Nombre de la tienda</mat-label>
                        <input matInput placeholder="Nombre Tienda" name="nombreT" id="nombreT" formControlName="nombreT" #nombreT required>
                        <mat-hint>{{nombreT.value?.length || 0}}/45</mat-hint>
                        <!-- <mat-error *ngIf="getControl('nombreT')">Nombre de la tienda incorrecto
                        </mat-error> -->
                    </mat-form-field>

                    <mat-checkbox formControlName="terms" name="terms" #terms required>Acepto los <a routerLink="/terminos-condiciones" target="_blank">terminos y condiciones.</a>
                    </mat-checkbox>
                    <mat-checkbox formControlName="politics" name="politics" #politics required>Acepto la <a href="http://triidy.com/wp-content/uploads/2022/12/POLITICA-DE-TRATAMIENTO-DE-DATOS-TRIIDY-PERSONALES.pdf" target="_blank" rel="noopener noreferrer">Política de
                            tratamiento de datos</a> y el <a href="http://triidy.com/wp-content/uploads/2023/02/V2-Autorizacion-tratamiento-de-datos.pdf" target="_blank" rel="noopener noreferrer">Aviso
                            de privacidad</a>
                    </mat-checkbox>
                    <mat-checkbox formControlName="sendSMS" name="sendSms" matTooltip="Te notificaremos actualizaciones y ofertas de nuestra plataforma">
                        Acepto el envio de mensajes de texto y/o correo electrónico.
                    </mat-checkbox>

                    <div class="cont-btn">
                        <button type="submit" class="btn" [disabled]="!registerForm.valid" (click)="registroTienda()">Iniciar Registro</button>
                        <!-- <p class="errorTerms" *ngIf="!registerForm.valid">Debes aceptar los terminos y condiciones</p> -->
                        <ng-container *ngIf="registerForm.touched">
                            <ul class="errorTerms">
                                <li *ngIf="!registerForm.valid && registerForm.controls.correo.errors?.email">No tiene formato de correo</li>
                                <li *ngIf="!registerForm.valid && registerForm.controls.correo.errors?.required">Falta un correo electronico</li>
                                <li *ngIf="!registerForm.valid && showErrorSpace">El correo contiene un espacio</li>
                                <li *ngIf="!registerForm.valid && registerForm.controls.nombreT.errors?.required">Falta el nombre de la tienda</li>
                                <li *ngIf="!registerForm.valid && registerForm.controls.nombreT.errors?.pattern">
                                    Caracter no permitido en el nombre de la tienda</li>
                                <li *ngIf="!registerForm.valid && registerForm.controls.politics.errors?.required">
                                    Acepta las politicas de tratamiento de datos</li>
                                <li *ngIf="!registerForm.valid && registerForm.controls.terms.errors?.required">Acepta los terminos y condiciones
                                </li>
                            </ul>
                        </ng-container>
                    </div>
                </form>
            </div>
            <div class="opc">
                <p>¿Ya tienes una cuenta? <span (click)="redirigirInicioSesion()">Iniciar Sesión</span></p>
            </div>
        </div>
    </div>
</div>